import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import { Sparkles } from "lucide-react";

export default function ReminderBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin") return null;
  if (user.profile_complete) return null;

  return (
    <div
      className="rounded-lg border border-[#00868e]/25 bg-[#00868e]/8 px-6 py-4 flex items-start gap-4"
      style={{ background: "rgba(0,134,142,0.06)" }}
      data-testid="profile-reminder-banner"
    >
      <div className="mt-0.5 h-9 w-9 rounded-full bg-[#005870] text-white flex items-center justify-center shrink-0">
        <Sparkles size={16} />
      </div>
      <div className="flex-1">
        <div className="font-serif-cn text-[#003645] font-semibold text-base">
          {t("home.reminderTitle")}
        </div>
        <div className="mt-1 text-sm text-[#4a6e77] leading-relaxed">
          {t("home.reminderBody")}
        </div>
      </div>
      <Link
        to="/profile"
        className="shrink-0 px-4 py-2 rounded-full bg-[#005870] text-white text-sm font-medium hover:bg-[#003645] transition-colors duration-200"
        data-testid="banner-complete-profile-btn"
      >
        {t("home.completeProfile")}
      </Link>
    </div>
  );
}
